'use strict';

const collectionFactory = require('./collection.factory');

const websiteConfigCollection = collectionFactory({
    dataUrl: 'getwebsiteconfig',

    getShowConfig() {
        return this.get('showConfig') || {};
    },

    isFreeCancellationEnabled() {
        return this.getShowConfig().freeCancellation;
    },

    isFreeCancellationHeader() {
        return this.get('freeCnxlHeader');
    },

    getAB() {
        return this.get('ab') || {};
    },

    isMeta() {
        return this.get('meta') || false;
    },

    isImplicitAcceptance() {
        return this.get('implicitAcceptance');
    },

    isPbAncillariesMockEnabled() {
        return this.get('pbAncillariesMockEnabled');
    },

    getCheckinService() {
        return this.get('checkinService');
    },

    isCheckinRequiresMoreInfo() {
        return this.get('checkinRequiresMoreInfo');
    },

    isCheckinAvailableInsurances() {
        return this.get('checkinAvailableInsurances');
    },

    getClientInterface() {
        return this.get('clientInterface');
    },
});

module.exports.getInstance = websiteConfigCollection.getInstance;
